<div class="grid-row-wrap">
<div class="grid-row pointer" (click)="toggleExpand()">
    <div class="list-item select-cell" (click)="pendingApprovalTab$() && toggleSelect($event)">
        <input *ngIf="pendingApprovalTab$()" type="checkbox" class="select-checkbox" [checked]="isSelected" />
    </div>
    <div class="list-item chevron-cell" [class.expanded]="isExpanded">
        <img class="chevron-icon" src="/assets/images/expand_more.svg" />
    </div>
    <div class="list-item flex-2 ellipsis ">
        <p class="ellipsis xxx"> {{approval?.questionnarieName}}</p>
        <div class="tooltip-abs" *ngIf="approval?.questionnarieName">
            <p>{{approval?.questionnarieName}}</p>
        </div>
    </div>
    <div class="list-item flex-1">{{ approval?.recipientId }}</div>
    <div class="list-item flex-1">{{approval?.createDate |queDate }}</div>
    <div class="list-item flex-1_2 sender-name-wrap" (mouseenter)="onSenderNameHover()">
        <div class="circle">
            <p>
                {{
                approval?.user?.firstName
                ? approval?.user?.firstName?.charAt(0)?.toUpperCase()
                : ""
                }}
            </p>
            <p>
                {{
                approval?.user?.lastName
                ? approval?.user?.lastName?.charAt(0)?.toUpperCase()
                : ""
                }}
            </p>
        </div>
        <p class="name">{{ approval?.user?.firstName }} {{ approval?.user?.lastName }}</p>
        <div class="tooltip-abs sender-total-tooltip">
            <p *ngIf="senderApprovedTotal() !== undefined; else loadingSenderTotal">
                <span>{{ (pendingApprovalTab$() ? 'column.approvals.senderPendingTotalLabel' : 'column.approvals.senderApprovedTotalLabel') | translate }}</span>
                {{ senderApprovedTotal() | number:'1.0-2' }} ₪
            </p>
            <ng-template #loadingSenderTotal>
                <p translate>column.approvals.senderApprovedTotalLoading</p>
            </ng-template>
        </div>
    </div>
    <div *ngIf="downloadRecordsTab$()" class="list-item flex-1_2" [title]="approval?.approverNames">
        <p class="name">{{ approval?.approverNames }}</p>
    </div>
    <div *ngIf="afterApprovalTab$()" class="list-item flex-2 ellipsis ">
        <que-approval-status [status]="approval?.status"></que-approval-status>
    </div>
    <div *ngIf="downloadRecordsTab$() || afterApprovalTab$()" class="list-item flex-1">{{approval?.updateDate |queDate }}</div>
    <div *ngIf="afterApprovalTab$()" class="list-item flex-1 payroll-months"
        [class.payroll-duplicate]="(approval?.payrollExportCount ?? 0) > 1"
        [title]="(approval?.payrollExportCount ?? 0) > 1 ? ('column.approvals.payrollDuplicateWarning' | translate: { count: approval?.payrollExportCount }) : ''">
        <p *ngFor="let month of approval?.payrollMonths">{{ month | quePayrollMonth }}</p>
        <p *ngIf="(approval?.payrollExportCount ?? 0) > 1" class="payroll-duplicate-badge">
            ⚠ {{ 'column.approvals.payrollExportCountLabel' | translate: { count: approval?.payrollExportCount } }}
        </p>
    </div>
    <div class="list-item flex-1_8">
        <que-extra-details [requiredAmount]="approval?.requiredAmount" [comment]="approval?.status == eApprovalStatus.Rejected ? approval?.comment : null"
            [approvedAmount]="approval?.status == eApprovalStatus.Approved ? approval?.approvedAmount : null"
            [expenseRowsCount]="approval?.expenseRowsCount"></que-extra-details>
    </div>
    <div class="list-item flex-half last">
        <que-approvals-menu-item (editEvent)="editGroup()" [approval]="approval"></que-approvals-menu-item>
    </div>
</div>
<que-approval-expense-rows
    *ngIf="isExpanded"
    [rows]="expenseRows"
    [loading]="isLoadingExpenseRows"
    [error]="expenseRowsError"
    [approvalId]="approval?.id"
    [canEdit]="approval?.status === eApprovalStatus.PendingApproval"
    (rowClick)="approvalClick()">
</que-approval-expense-rows>
</div>